import React from "react";
import TkBasicHeader from "../BasicHeader";
import { TkHeaderProps } from "../../../../../../type/componentsType/TkHeaderType";
import "../BasicHeader/_style.scss";
import TkQaButton from "../../QaButton";
import { Box } from "@mui/material";

/**
 * ヘッダー部品（退職者）
 * ユーザタイプが退職者の場合のページのヘッダー
 * @return TkHeader ヘッダー部品（退職者）
 */
export const TkTaisyokusyaHeader: React.FC<TkHeaderProps> = (props: any) => {
  const { hideButton } = props;

  return (
    <Box data-testid="tkTaisyokusyaHeader">
      <TkBasicHeader>
        <TkBasicHeader.Slot slot="right">
          {!hideButton && (
            <TkQaButton></TkQaButton>
          )}
        </TkBasicHeader.Slot>
      </TkBasicHeader>
    </Box>
  );
};

export default TkTaisyokusyaHeader;
